module.exports = __webpack_public_path__ + "static/3-ca0533cd2940a9331542375c253a2f03.jpg";